(function () {
    var k = "MD5";
    var l = {
        hc: 0, bp: "", ch: 8, bm: function (s) {
            if (s) {
                return this.b6(this.cm(this.sb(s), s.length * this.ch))
            }
            return "1B2M2Y8AsgTpgAmY7PhCfg"
        }, cc: function (s) {
            if (s) {
                return this.bh(this.cm(this.sb(s), s.length * this.ch))
            }
            return "d41d8cd98f00b204e9800998ecf8427e"
        }, cm: function (x, e) {
            x[e >> 5] |= 0x80 << ((e) % 32);
            x[(((e + 64) >>> 9) << 4) + 14] = e;
            var a = 1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d = 271733878;
            for (var i = 0; i < x.length; i += 16) {
                var f = a;
                var g = b;
                var h = c;
                var j = d;
                a = this.mf(a, b, c, d, x[i + 0], 7, -680876936);
                d = this.mf(d, a, b, c, x[i + 1], 12, -389564586);
                c = this.mf(c, d, a, b, x[i + 2], 17, 606105819);
                b = this.mf(b, c, d, a, x[i + 3], 22, -1044525330);
                a = this.mf(a, b, c, d, x[i + 4], 7, -176418897);
                d = this.mf(d, a, b, c, x[i + 5], 12, 1200080426);
                c = this.mf(c, d, a, b, x[i + 6], 17, -1473231341);
                b = this.mf(b, c, d, a, x[i + 7], 22, -45705983);
                a = this.mf(a, b, c, d, x[i + 8], 7, 1770035416);
                d = this.mf(d, a, b, c, x[i + 9], 12, -1958414417);
                c = this.mf(c, d, a, b, x[i + 10], 17, -42063);
                b = this.mf(b, c, d, a, x[i + 11], 22, -1990404162);
                a = this.mf(a, b, c, d, x[i + 12], 7, 1804603682);
                d = this.mf(d, a, b, c, x[i + 13], 12, -40341101);
                c = this.mf(c, d, a, b, x[i + 14], 17, -1502002290);
                b = this.mf(b, c, d, a, x[i + 15], 22, 1236535329);
                a = this.mg(a, b, c, d, x[i + 1], 5, -165796510);
                d = this.mg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = this.mg(c, d, a, b, x[i + 11], 14, 643717713);
                b = this.mg(b, c, d, a, x[i + 0], 20, -373897302);
                a = this.mg(a, b, c, d, x[i + 5], 5, -701558691);
                d = this.mg(d, a, b, c, x[i + 10], 9, 38016083);
                c = this.mg(c, d, a, b, x[i + 15], 14, -660478335);
                b = this.mg(b, c, d, a, x[i + 4], 20, -405537848);
                a = this.mg(a, b, c, d, x[i + 9], 5, 568446438);
                d = this.mg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = this.mg(c, d, a, b, x[i + 3], 14, -187363961);
                b = this.mg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = this.mg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = this.mg(d, a, b, c, x[i + 2], 9, -51403784);
                c = this.mg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = this.mg(b, c, d, a, x[i + 12], 20, -1926607734);
                a = this.mh(a, b, c, d, x[i + 5], 4, -378558);
                d = this.mh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = this.mh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = this.mh(b, c, d, a, x[i + 14], 23, -35309556);
                a = this.mh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = this.mh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = this.mh(c, d, a, b, x[i + 7], 16, -155497632);
                b = this.mh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = this.mh(a, b, c, d, x[i + 13], 4, 681279174);
                d = this.mh(d, a, b, c, x[i + 0], 11, -358537222);
                c = this.mh(c, d, a, b, x[i + 3], 16, -722521979);
                b = this.mh(b, c, d, a, x[i + 6], 23, 76029189);
                a = this.mh(a, b, c, d, x[i + 9], 4, -640364487);
                d = this.mh(d, a, b, c, x[i + 12], 11, -421815835);
                c = this.mh(c, d, a, b, x[i + 15], 16, 530742520);
                b = this.mh(b, c, d, a, x[i + 2], 23, -995338651);
                a = this.mi(a, b, c, d, x[i + 0], 6, -198630844);
                d = this.mi(d, a, b, c, x[i + 7], 10, 1126891415);
                c = this.mi(c, d, a, b, x[i + 14], 15, -1416354905);
                b = this.mi(b, c, d, a, x[i + 5], 21, -57434055);
                a = this.mi(a, b, c, d, x[i + 12], 6, 1700485571);
                d = this.mi(d, a, b, c, x[i + 3], 10, -1894986606);
                c = this.mi(c, d, a, b, x[i + 10], 15, -1051523);
                b = this.mi(b, c, d, a, x[i + 1], 21, -2054922799);
                a = this.mi(a, b, c, d, x[i + 8], 6, 1873313359);
                d = this.mi(d, a, b, c, x[i + 15], 10, -30611744);
                c = this.mi(c, d, a, b, x[i + 6], 15, -1560198380);
                b = this.mi(b, c, d, a, x[i + 13], 21, 1309151649);
                a = this.mi(a, b, c, d, x[i + 4], 6, -145523070);
                d = this.mi(d, a, b, c, x[i + 11], 10, -1120210379);
                c = this.mi(c, d, a, b, x[i + 2], 15, 718787259);
                b = this.mi(b, c, d, a, x[i + 9], 21, -343485551);
                a = this.sa(a, f);
                b = this.sa(b, g);
                c = this.sa(c, h);
                d = this.sa(d, j)
            }
            return [a, b, c, d]
        }, mc: function (q, a, b, x, s, t) {
            return this.sa(this.br(this.sa(this.sa(a, q), this.sa(x, t)), s), b)
        }, mf: function (a, b, c, d, x, s, t) {
            return this.mc((b & c) | ((~b) & d), a, b, x, s, t)
        }, mg: function (a, b, c, d, x, s, t) {
            return this.mc((b & d) | (c & (~d)), a, b, x, s, t)
        }, mh: function (a, b, c, d, x, s, t) {
            return this.mc(b ^ c ^ d, a, b, x, s, t)
        }, mi: function (a, b, c, d, x, s, t) {
            return this.mc(c ^ (b | (~d)), a, b, x, s, t)
        }, sa: function (x, y) {
            var a = (x & 0xFFFF) + (y & 0xFFFF);
            var b = (x >> 16) + (y >> 16) + (a >> 16);
            return (b << 16) | (a & 0xFFFF)
        }, br: function (a, b) {
            return (a << b) | (a >>> (32 - b))
        }, sb: function (a) {
            var b = [];
            var c = (1 << this.ch) - 1;
            for (var i = 0; i < a.length * this.ch; i += this.ch)b[i >> 5] |= (a.charCodeAt(i / this.ch) & c) << (i % 32);
            return b
        }, bh: function (a) {
            var b = this.hc ? "0123456789ABCDEF" : "0123456789abcdef";
            var c = "";
            for (var i = 0; i < a.length * 4; i++) {
                c += b.charAt((a[i >> 2] >> ((i % 4) * 8 + 4)) & 0xF) + b.charAt((a[i >> 2] >> ((i % 4) * 8)) & 0xF)
            }
            return c
        }, b6: function (a) {
            var b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var c = "";
            for (var i = 0; i < a.length * 4; i += 3) {
                var d = (((a[i >> 2] >> 8 * (i % 4)) & 0xFF) << 16) | (((a[i + 1 >> 2] >> 8 * ((i + 1) % 4)) & 0xFF) << 8) | ((a[i + 2 >> 2] >> 8 * ((i + 2) % 4)) & 0xFF);
                for (var j = 0; j < 4; j++) {
                    if (i * 8 + j * 6 > a.length * 32) c += this.bp; else c += b.charAt((d >> 6 * (3 - j)) & 0x3F)
                }
            }
            return c
        }
    };
    window[k] = {
        calc: function (s) {
            return l.cc(s)
        }, b64: function (s) {
            return l.bm(s)
        }
    }
}());